import React, { useState } from "react";
import { isMobile } from "react-device-detect";

function TelegramIcon() {
  const [isOverTwitter, setOverTwitter] = useState();
  return (
    <div
      onMouseEnter={() => setOverTwitter(true)}
      onMouseLeave={() => setOverTwitter(false)}
      onMouseDown={() => setOverTwitter(true)}
      onMouseUp={() => {
        setTimeout(() => {
          setOverTwitter(false);
        }, 500);
      }}
    >
      <svg
        width="36px"
        height="30px"
        viewBox="0 0 36 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={`${isOverTwitter ? "hovered" : "normal"}`}
        style={{ width: isMobile ? "18px" : "" }}
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity="0.800000012"
        >
          <g id="Group-38" fillRule="nonzero">
            <path
              d="M9,17.0803147 L12.9297642,27.980162 C12.9297642,27.980162 13.4210883,29 13.9471914,29 C14.4732946,29 22.29832,20.8424022 22.29832,20.8424022 L31,4 L9.14022057,14.2667013 L9,17.0803147 Z"
              id="Path"
              fill="#C8DAEA"
            ></path>
            <path
              d="M13.7719451,20 L13.013286,27.921263 C13.013286,27.921263 12.6957207,30.3484213 15.1657347,27.921263 C17.6357486,25.4941047 20,23.6224656 20,23.6224656"
              id="Path"
              fill="#A9C6D8"
            ></path>
            <path
              d="M8.85104594,17.4865879 L0.720849476,14.8104857 C0.720849476,14.8104857 -0.250798671,14.4122395 0.0620720327,13.5091742 C0.126478424,13.322952 0.256401662,13.1644949 0.645060921,12.8921731 C2.44649659,11.6236748 33.9881387,0.170731571 33.9881387,0.170731571 C33.9881387,0.170731571 34.8787237,-0.132440349 35.4039689,0.0692068392 C35.6685137,0.151935531 35.8684709,0.372157119 35.9272708,0.645541987 C35.9840243,0.882713756 36.0077576,1.12672296 35.9977847,1.37051832 C35.9952862,1.58142052 35.9700233,1.7768977 35.950868,2.08343508 C35.7587593,5.21471582 30.0099336,28.584475 30.0099336,28.584475 C30.0099336,28.584475 29.6659702,29.9519739 28.4336427,29.9988099 C27.8217504,30.0187777 27.2280795,29.7867743 26.7887812,29.3560069 C24.3704878,27.2545571 16.0120928,21.5798295 14.1651285,20.3318044 C14.0808404,20.2737788 14.0255574,20.1817204 14.0135514,20.0793949 C13.9877333,19.9478615 14.1293163,19.7849171 14.1293163,19.7849171 C14.1293163,19.7849171 28.6834951,6.7157113 29.0707663,5.34372514 C29.1007486,5.23743268 28.9874821,5.18498758 28.8353498,5.23154312 C27.8686987,5.59080605 11.1113771,16.2814725 9.2619143,17.4613469 C9.12878475,17.5020376 8.98807519,17.5106819 8.85104594,17.4865879 Z"
              id="Path"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default TelegramIcon;
